import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';

import { LazySpaceCreatePage } from '../lazyComponents.js';
import { navdexEnd } from '../naxdev.js';

export const CreateBlogRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS({ params: { spaceKey } }: RouteMatch): {
		Screen: {
			showPremiumOnboarding: boolean;
			screenEvent: {
				attributes: {
					navdexPointType: string;
				};
				name: string;
			};
			pageState: {
				spaceKey: string;
			};
		};
		MainLayout: boolean;
	};
} = (): React.JSX.Element => <LazySpaceCreatePage contentType="blogpost" />;

CreateBlogRoute.NAVIGATION_PARAMS = ({
	params: { spaceKey },
}: RouteMatch): {
	Screen: {
		showPremiumOnboarding: boolean;
		screenEvent: {
			attributes: {
				navdexPointType: string;
			};
			name: string;
		};
		pageState: {
			spaceKey: string;
		};
	};
	MainLayout: boolean;
} => ({
	Screen: {
		showPremiumOnboarding: false,
		screenEvent: { name: 'editPageScreen', ...navdexEnd },
		pageState: { spaceKey },
	},
	MainLayout: false,
});
